module.exports = __webpack_public_path__ + "img/06univs.2e39959f.png";